import * as React from "react";
import {
  DataGrid,
  GridFooterContainer,
  useGridApiContext,
  useGridSelector,
  gridRowCountSelector,
} from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import PropTypes from "prop-types";

function CustomFooter() {
  const apiRef = useGridApiContext();
  const rowCount = useGridSelector(apiRef, gridRowCountSelector);

  return (
    <GridFooterContainer>
      <div style={{ padding: "0 16px", fontSize: "13px" }}>
        {`全${rowCount}件`}
      </div>
    </GridFooterContainer>
  );
}

export default function MemberDataTableForReport({
  members,
  setTargetMembers,
  individualPrint,
  selectionModel,
  setSelectionModel,
  loading,
}) {
  const columns = [
    //{ field: "id", headerName: "ID", width: 70 },
    {
      field: "DownloadButton",
      headerName: "個別評価シート",
      description: "",
      sortable: false,
      width: 150,
      align: "center",
      disableClickEventBubbling: true,
      renderCell: (params) => (
        <Button
          variant="contained"
          color="primary"
          onClick={(e) => {
            clicked3(e, params.row.id);
          }}
        >
          評価シート出力
        </Button>
      ),
    },
    {
      field: "NickName",
      headerName: "表示名",
      width: 150,
    },
    {
      field: "DataExists",
      headerName: "今回の測定データ有無",
      width: 200,
      align: "center",
    },
  ];

  const clicked2 = (ids) => {
    const selectedIDs = new Set(ids);
    const selectedRowData = members.filter((row) =>
      selectedIDs.has(row.id.toString())
    );

    setSelectionModel(ids);
    setTargetMembers(selectedRowData);
  };

  const clicked3 = (event, id) => {
    event.stopPropagation();
    individualPrint(id);
  };

  return (
    <div style={{ height: 320, width: "100%" }}>
      <DataGrid
        rows={members ?? []}
        loading={loading ?? false}
        columns={columns}
        pageSize={members ? members.length : 0}
        rowsPerPageOptions={[members ? members.length : 0]}
        checkboxSelection={true}
        density="compact"
        selectionModel={selectionModel}
        onSelectionModelChange={(ids) => clicked2(ids)}
        components={{ Footer: CustomFooter }}
        initialState={{ sorting: { sortModel: [{ field: "NickName", sort: "asc" }] } }}
      />
    </div>
  );
}

MemberDataTableForReport.propTypes = {
  members: PropTypes.object,
  setTargetMembers: PropTypes.any,
  individualPrint: PropTypes.any,
  selectionModel: PropTypes.array,
  setSelectionModel: PropTypes.func,
  loading: PropTypes.bool,
};
